import * as z from 'zod/mini'
import { placeFields } from '../../schemas/place'
import { PlaceStatus } from '../../types'

/** A place URL (`.../places/:placeId`), looked up by `PlaceGuard` within the premise. */
export const placeParams = z.object({ placeId: z.uuid() })
export type PlaceParams = z.infer<typeof placeParams>

const placeBodyFields = {
  name: placeFields.name,
  capacity: placeFields.capacity.check(z.positive()),
  /** Resolved within the premise in `PlaceService`; an id from elsewhere is a 404. */
  activityIds: z.array(z.uuid()),
}

export const createPlaceBody = z.object(placeBodyFields)
export type CreatePlaceBody = z.infer<typeof createPlaceBody>

export const editPlaceBody = z.partial(z.object(placeBodyFields))
export type EditPlaceBody = z.infer<typeof editPlaceBody>

export const setPlaceStatusBody = z.object({ status: z.enum(PlaceStatus) })
export type SetPlaceStatusBody = z.infer<typeof setPlaceStatusBody>
